/* bios-page-transitions.js — fires a brief pageStaticBurst() on every
   internal-link click so navigating between BIOS surfaces feels like a
   hardware event rather than a quiet browser jump. Loaded globally from
   theme.liquid so it works across catalog / PDP / cart / search / account.

   Skips: external links, downloads, anchors, mailto/tel, and links
   already inside the SYS_CART panel / overlay (those have their own
   tones). Also skips when SND is muted (BiosAudio handles that
   internally — calling pageStaticBurst() while muted is a no-op). */
(function biosPageTransitions() {
  'use strict';

  function isInternal(a) {
    if (!a || !a.href) return false;
    if (a.target === '_blank') return false;
    if (a.hasAttribute('download')) return false;
    var h = a.getAttribute('href') || '';
    if (h.charAt(0) === '#') return false;
    if (h.indexOf('mailto:') === 0 || h.indexOf('tel:') === 0) return false;
    /* Cross-origin? Compare hostname. */
    try {
      if (a.hostname && a.hostname !== window.location.hostname) return false;
    } catch (_) {}
    return true;
  }

  var CHECKOUT_SEL = '.bios-cart-checkout, .bios-cart-pg-checkout, .ps-cart-checkout';

  /* Capture phase so we fire BEFORE any stopPropagation in inner handlers.
     Internal-link clicks: pre-empt the navigation, play a step-end
     glitch overlay (window.biosPageGlitch from theme.liquid), then
     navigate after the animation. The destination page's BIOS splash
     handles the "decode-in" half — together they bracket every nav
     with a signal-disturbance pair. */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href]');
    if (!isInternal(a)) return;

    /* Checkout buttons get the modem handshake instead of the glitch
       (the dial-up sequence is the signature transition for that
       specific commit point). */
    if (a.matches(CHECKOUT_SEL) || a.closest(CHECKOUT_SEL)) {
      try { if (window.BiosAudio) window.BiosAudio.checkoutConnect(); } catch (_) {}
      return;
    }

    /* Skip links inside the cart panel / overlay / search popup — those
       open in-page rather than navigating. */
    if (a.closest('#bios-cart-panel, #bios-overlay, .bios-results-popup')) return;

    /* Modified-click / middle-click open in new tab — let browser handle. */
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;

    /* Same-page anchor jumps (#section) — no transition needed. */
    if (a.pathname === location.pathname && a.search === location.search && a.hash) return;

    /* Ahead of the glitch: play the static-burst sound concurrently. */
    try { if (window.BiosAudio) window.BiosAudio.pageStaticBurst(); } catch (_) {}

    /* If the glitch helper is available, intercept the click and
       navigate after the animation. Otherwise fall through to the
       browser's default navigation. */
    if (window.biosPageGlitch) {
      e.preventDefault();
      var href = a.href;
      window.biosPageGlitch(function () { window.location.href = href; });
    }
  }, true);

  /* Same idea for form submits — "packet dispatched" rather than silent. */
  document.addEventListener('submit', function (e) {
    if (!window.BiosAudio || !window.BiosAudio.transmit) return;
    var f = e.target;
    if (!f || f.tagName !== 'FORM') return;
    /* Search forms handled by the live-typing system already; skip. */
    if (f.matches('[action*="/search"]')) return;
    try { window.BiosAudio.transmit(); } catch (_) {}
  }, true);
})();
